import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_document_hdr_RowClass, bl_aat_claim_document_line_RowClass} from '../../../dbschema';

export class MyClaimDocumentContainerModel extends BaseContainerModel {
  bl_aat_claim_document_hdr: bl_aat_claim_document_hdr_RowClass = new bl_aat_claim_document_hdr_RowClass();
  bl_aat_claim_document_lines: bl_aat_claim_document_line_RowClass[] = [];
}

export class ReguestByGuidContainer extends BaseContainerModel {
  guids: string[] = [];
}
